import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import './DMO.css'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  theme: {
    options: { customProperties: true }
  }
})

export default vuetify
